/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.set.defs'

type $nsid = typeof $nsid

export { $nsid }

type Set$0 = {
  $type?: 'tools.ozone.set.defs#set'
  name: string
  description?: string
}

export type { Set$0 as Set }

const set$0 = /*#__PURE__*/ l.typedObject<Set$0>(
  $nsid,
  'set',
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string({ minLength: 3, maxLength: 128 }),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 1024, maxLength: 10240 }),
    ),
  }),
)

export { set$0 as 'set' }

type SetView = {
  $type?: 'tools.ozone.set.defs#setView'
  name: string
  description?: string
  setSize: number
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString
}

export type { SetView }

const setView = /*#__PURE__*/ l.typedObject<SetView>(
  $nsid,
  'setView',
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string({ minLength: 3, maxLength: 128 }),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 1024, maxLength: 10240 }),
    ),
    setSize: /*#__PURE__*/ l.integer(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { setView }
